// File: src/components/AITestComponent.jsx
// Description: Test component to verify AI server integration

import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  Stack,
  Alert,
  CircularProgress
} from '@mui/material';
import AIService from '../services/AIService';

const AITestComponent = () => {
  const [testInput, setTestInput] = useState('User Profile: {"name": "John Doe", "jobTitle": "AI Researcher", "industry": "tech", "experience": "5 years", "location": "San Francisco", "skills": ["Python", "TensorFlow", "Neural Networks"], "bio": "Expert in machine learning and AI applications with 5+ years in research. Passionate about bridging the gap between academic research and practical product development."}\nUser Question: How can I transition from research to product management while leveraging my AI expertise?');
  
  const [careerTestInput, setCareerTestInput] = useState('User Profile: {"name": "John Doe", "jobTitle": "AI Researcher", "industry": "Biotechnology", "experience": "5 years", "location": "San Francisco", "skills": ["Python", "TensorFlow", "Neural Networks", "Research Methods"], "bio": "Expert in machine learning and AI applications with 5+ years in research. Passionate about bridging the gap between academic research and practical product development.", "education": "PhD in Computer Science", "currentCompany": "Research Institute", "careerGoals": ["Transition to product management", "Lead AI teams", "Start AI consulting business"], "targetRoles": ["AI Product Manager", "AI Strategy Director", "AI Consultant"]}');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const testAIServer = async (agentName) => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      console.log(`Testing AI server with agent: ${agentName}`);
      const response = await AIService.callAIServer(agentName, testInput);
      console.log('AI server response:', response);
      setResult(response);
    } catch (err) {
      console.error('AI server test failed:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const testCareerInsights = async () => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      console.log('Testing Career Insights API');
      const userProfile = JSON.parse(careerTestInput.replace('User Profile: ', ''));
      const response = await AIService.getCareerInsights(userProfile);
      console.log('Career Insights response:', response);
      setResult(response);
    } catch (err) {
      console.error('Career Insights test failed:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card sx={{ maxWidth: 600, mx: 'auto', mt: 4 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          AI Server Integration Test
        </Typography>
        
        <TextField
          fullWidth
          label="Test Input"
          value={testInput}
          onChange={(e) => setTestInput(e.target.value)}
          multiline
          rows={3}
          sx={{ mb: 2 }}
        />

                <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
          <Button
            variant="contained"
            onClick={() => testAIServer("Profile Analysis and Collaboration Insight Agent")}
            disabled={loading}
          >
            Test Profile Analysis
          </Button>
          
          <Button
            variant="contained"
            onClick={() => testAIServer("Personalized Profile Generator")}
            disabled={loading}
          >
            Test Profile Personalization
          </Button>
          
                      <Button
             variant="contained"
             onClick={() => testAIServer("Profile Analysis and Collaboration Insight Agent")}
             disabled={loading}
           >
             Test AI General Assistant
           </Button>
           
           <Button
             variant="contained"
             onClick={() => testAIServer("Career Insights Agent")}
             disabled={loading}
           >
             Test Career Insights
           </Button>
        </Stack>

        {/* Career Insights Test */}
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2" gutterBottom>
            Test Career Insights with Sample Profile:
          </Typography>
          <TextField
            fullWidth
            label="Career Test Input"
            value={careerTestInput}
            onChange={(e) => setCareerTestInput(e.target.value)}
            multiline
            rows={3}
            sx={{ mb: 1 }}
          />
          <Button
            variant="contained"
            color="secondary"
            onClick={testCareerInsights}
            disabled={loading}
            fullWidth
          >
            Test Career Insights API
          </Button>
        </Box>

        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
            <CircularProgress />
          </Box>
        )}

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {result && (
          <Box>
            <Typography variant="subtitle2" gutterBottom>
              AI Server Response:
            </Typography>
            <Box
              sx={{
                p: 2,
                bgcolor: 'grey.100',
                borderRadius: 1,
                fontFamily: 'monospace',
                fontSize: '0.875rem',
                whiteSpace: 'pre-wrap',
                maxHeight: 300,
                overflow: 'auto'
              }}
            >
              {JSON.stringify(result, null, 2)}
            </Box>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default AITestComponent;
